export class Overlay {
  $body;
  $overlay;

  constructor() {
    this.$body = this.getBody();
    this.$overlay = this.getOverlay();
  }
  openOverlay() {
    this.$body.css('overflow', 'hidden');
    this.$body.css('position', 'relative');
    this.$overlay.addClass('active');
  }

  closeOverlay() {
    this.$body.css('overflow', 'unset');
    this.$body.css('position', 'unset');
    this.$overlay.removeClass('active');
  }

  getBody() {
    return $('body', document).first();
  }

  getOverlay() {
    return $('.overlay', document).first();
  }
}
